/**
 * LinkNavigator handles linking to relative and absolute URLs from a rich file.
 * Mostly used in geojson pins or within mermaid charts
 *
 * @param hasParent boolean Is this class instantiated from within an iframe?
 */
class LinkNavigator {
  constructor({hasParent = false}) {
    this.hasParent = hasParent
    this.handleLink = this.handleLink.bind(this)
    this.navigateTo = this.navigateTo.bind(this)
    this.navigateRelative = this.navigateRelative.bind(this)
    this.navigateDirect = this.navigateDirect.bind(this)
  }

  // Handle the clicking of a link in the document in the context-appropriate way
  handleLink(e) {
    const $target = $(e.currentTarget)
    const href = $target.attr('href') || $target.attr('xlink:href') || ''

    // Don't bother processing nothing
    if (!href.length) {
      return
    }
    // anchors can just pass through
    if (href.match(/^#/)) {
      return true
    }

    e.preventDefault()
    try {
      return this.navigateTo(href)
    } catch (error) {
      window.debug(`Navigation to '${href}' failed:`, error)
      const failClass = 'failed'
      const failInterval = 500

      $target.addClass(failClass)
      return setTimeout(() => $target.removeClass(failClass), failInterval)
    }
  }

  // Navigate to `href` either by asking the parent for the move, or by
  // performing the navigation myself.
  navigateTo(href) {
    if (href.match(/^https?:\/\//) || href.match(/^\/\//)) {
      this.navigateDirect(href)
    } else {
      this.navigateRelative(href)
    }
  }

  navigateRelative(relHref) {
    const rootUrl = $('body').data('github-hostname')
    const prefixedRelHref = relHref[0] === '/' ? relHref : `/${relHref}`
    const url = `//${rootUrl}${prefixedRelHref}`

    return this.navigateDirect(url)
  }

  navigateDirect(href) {
    if (this.hasParent) {
      window.top.location.href = href
    } else {
      window.location.href = href
    }
  }
}

export default LinkNavigator
